import { ConfirmationEntity } from '../../models/confirmation/ConfirmationEntity';
import { AppState } from '../reducers/root';

export const hasPendingCommandConfirmations = (state: AppState): boolean =>
  state.confirmation.pending.length > 0;

export const getFirstPendingCommandConfirmation = (
  state: AppState
): ConfirmationEntity => state.confirmation.pending[0];
